<template>
  <font-awesome-icon v-bind="$attrs" @click="$emit('click')"/>
</template>

<script>
export default {
  name: 'JexyIcon'
}
</script>
